import "core-js/modules/esnext.global-this.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
import "core-js/modules/esnext.global-this.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import mitt from 'mitt';
/*! @carvana/microfrontend v2.2.0 - Tue Aug 01 2023 19:40:21 GMT+0000 (Coordinated Universal Time) */

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  return value;
};

var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };

    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };

    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };

    step((generator = generator.apply(__this, __arguments)).next());
  });
};

var FetchError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(FetchError, _Error);

  function FetchError(msg) {
    var _this;

    _this = _Error.call(this, msg) || this;
    _this.name = "FetchError";
    _this.stack = msg == null ? void 0 : msg.stack;
    return _this;
  }

  return FetchError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DownloadFile = function DownloadFile(_0, _1, _2) {
  return __async(void 0, [_0, _1, _2], /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, responseType, _ref) {
    var http, fetchResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            http = _ref.http;
            _context.prev = 1;

            if (!http) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", http(url));

          case 4:
            _context.next = 6;
            return fetchWithTimeout(url);

          case 6:
            fetchResponse = _context.sent;

            if (fetchResponse.ok) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", Promise.reject(new FetchError("something went wrong when downloading file. status: " + fetchResponse.status)));

          case 9:
            if (!(fetchResponse && fetchResponse.ok)) {
              _context.next = 15;
              break;
            }

            _context.t0 = responseType;
            _context.next = _context.t0 === "text" ? 13 : 14;
            break;

          case 13:
            return _context.abrupt("return", fetchResponse.text());

          case 14:
            return _context.abrupt("return", fetchResponse.json());

          case 15:
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t1 = _context["catch"](1);
            return _context.abrupt("return", Promise.reject(new FetchError(_context.t1)));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 17]]);
  }));
};

var fetchWithTimeout = function fetchWithTimeout(input, init) {
  return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _ref2, _ref2$timeout, timeout, controller, id, response;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref2 = init || {}, _ref2$timeout = _ref2.timeout, timeout = _ref2$timeout === void 0 ? 3e3 : _ref2$timeout;
            controller = new AbortController();
            id = setTimeout(function () {
              return controller.abort();
            }, timeout);
            _context2.next = 5;
            return fetch(input, __spreadProps(__spreadValues({}, init), {
              signal: controller.signal
            }));

          case 5:
            response = _context2.sent;
            clearTimeout(id);
            return _context2.abrupt("return", response);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

var isSSR = function isSSR() {
  return typeof window === "undefined" || /ServerSideRendering|SSR/i.test(window.navigator && window.navigator.userAgent);
};

var getCookie = function getCookie(name) {
  var nameWithEquals = name + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(";");

  for (var i = 0; i < cookieArray.length; i++) {
    var cookie = cookieArray[i].trim();

    if (cookie.indexOf(nameWithEquals) === 0) {
      return cookie.substring(nameWithEquals.length, cookie.length);
    }
  }

  return "";
};

var joinUrl = function joinUrl() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.join("/").replace(/[/]+/g, "/").replace(/^(.+):\//, "$1://").replace(/^file:/, "file:/").replace(/\/(\?|&|#[^!])/g, "$1").replace(/\?/g, "&").replace("&", "?");
};

var isHTTPURL = function isHTTPURL(value) {
  try {
    return new URL(value) !== void 0;
  } catch (error) {
    return false;
  }
};

var DownloadManifestError = /*#__PURE__*/function (_Error2) {
  _inheritsLoose(DownloadManifestError, _Error2);

  function DownloadManifestError(msg) {
    var _this2;

    _this2 = _Error2.call(this, msg) || this;
    _this2.name = "DownloadManifestError";
    _this2.stack = msg == null ? void 0 : msg.stack;
    return _this2;
  }

  return DownloadManifestError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var defaultCacheTime = 5e3;

var DownloadManifest = function DownloadManifest(http, manifestCache2) {
  return function (manifestURL, moduleName, ttl) {
    if (ttl === void 0) {
      ttl = 5e3;
    }

    return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", new Promise(function (resolve, reject) {
                (function () {
                  return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                    var cacheTime, cache, manifestFile;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            cacheTime = 0;
                            if (typeof ttl === "number" && ttl) cacheTime = ttl;
                            if (ttl !== void 0 && typeof ttl === "boolean") cacheTime = ttl ? defaultCacheTime : 0;
                            manifestURL = getManifestURL(manifestURL, moduleName);
                            _context3.prev = 4;
                            cache = manifestCache2.get(manifestURL);

                            if (!cache) {
                              _context3.next = 8;
                              break;
                            }

                            return _context3.abrupt("return", resolve(cache));

                          case 8:
                            _context3.next = 10;
                            return DownloadFile(manifestURL, "json", {
                              http: http
                            }).catch(function (err) {
                              throw err;
                            });

                          case 10:
                            manifestFile = _context3.sent;

                            if (manifestFile && cacheTime > 0) {
                              manifestCache2.put(manifestURL, manifestFile, cacheTime);
                            }

                            return _context3.abrupt("return", resolve(manifestFile));

                          case 15:
                            _context3.prev = 15;
                            _context3.t0 = _context3["catch"](4);
                            return _context3.abrupt("return", reject(new DownloadManifestError(_context3.t0 + ": " + manifestURL + ": ")));

                          case 18:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, null, [[4, 15]]);
                  }));
                })();
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  };
};

var getManifestURL = function getManifestURL(originalManifestURL, moduleName) {
  if (isSSR()) return originalManifestURL;

  try {
    var cookieValue = getCookie(moduleName);
    if (!cookieValue) return originalManifestURL;

    if (isHTTPURL(cookieValue)) {
      return cookieValue;
    }

    var lastInstanceOfSlash = originalManifestURL.lastIndexOf("/");
    var urlWithoutFileName = originalManifestURL.substring(0, lastInstanceOfSlash);
    var fileName = originalManifestURL.substring(lastInstanceOfSlash + 1);
    var newManifestUrl = joinUrl(urlWithoutFileName, cookieValue, fileName);
    return newManifestUrl;
  } catch (error) {
    return originalManifestURL;
  }
};

var isError = function isError(err) {
  return err instanceof Error;
};

var FetchFileAndAddToGlobalError = /*#__PURE__*/function (_Error3) {
  _inheritsLoose(FetchFileAndAddToGlobalError, _Error3);

  function FetchFileAndAddToGlobalError(msg) {
    var _this3;

    _this3 = _Error3.call(this, msg) || this;
    _this3.name = "FetchFileAndAddToGlobalError";
    _this3.stack = msg == null ? void 0 : msg.stack;
    return _this3;
  }

  return FetchFileAndAddToGlobalError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var FetchFileAndAddToGlobal = function FetchFileAndAddToGlobal(moduleName, fileToLoad, opts) {
  return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", new Promise(function (resolve, reject) {
              (function () {
                return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  var _ref3, http, textFile, eval2, evalComponents;

                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.prev = 0;
                          _ref3 = opts || {}, http = _ref3.http;
                          _context5.next = 4;
                          return DownloadFile(fileToLoad, "text", {
                            http: http
                          }).catch(function (err) {
                            return err;
                          });

                        case 4:
                          textFile = _context5.sent;

                          if (!(typeof textFile !== "string" || isError(textFile))) {
                            _context5.next = 7;
                            break;
                          }

                          return _context5.abrupt("return", reject(new FetchFileAndAddToGlobalError("http call did not return a string")));

                        case 7:
                          if (textFile) {
                            eval2 = eval;
                            evalComponents = eval2(textFile);
                            globalThis[moduleName] = __spreadValues({}, evalComponents);
                          }

                          return _context5.abrupt("return", resolve(null));

                        case 11:
                          _context5.prev = 11;
                          _context5.t0 = _context5["catch"](0);
                          return _context5.abrupt("return", reject(new FetchFileAndAddToGlobalError(_context5.t0 + ": " + fileToLoad)));

                        case 14:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, null, [[0, 11]]);
                }));
              })();
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
};

var isFunction = function isFunction(fn) {
  return fn instanceof Function;
};

var isString = function isString(str) {
  return typeof str === "string";
};

var LoadBrowserScriptError = /*#__PURE__*/function (_Error4) {
  _inheritsLoose(LoadBrowserScriptError, _Error4);

  function LoadBrowserScriptError(msg) {
    var _this4;

    _this4 = _Error4.call(this, msg) || this;
    _this4.name = "LoadBrowserScriptError";
    _this4.stack = msg == null ? void 0 : msg.stack;
    return _this4;
  }

  return LoadBrowserScriptError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function createElementByExtension(extension, url) {
  switch (extension) {
    case "cjs":
    case "js":
    case "map":
    case "mjs":
      {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        return script;
      }

    case "css":
      {
        var link = document.createElement("link");
        link.href = url;
        link.rel = "stylesheet";
        link.type = "text/css";
        return link;
      }

    default:
      return null;
  }
}

var LoadBrowserScript = function LoadBrowserScript(url, opts) {
  return new Promise(function (resolve, reject) {
    var _a, _b, _c;

    try {
      var _ref4 = opts || {},
          _ref4$append = _ref4.append,
          append = _ref4$append === void 0 ? "body" : _ref4$append,
          _ref4$attributes = _ref4.attributes,
          attributes = _ref4$attributes === void 0 ? {
        async: true
      } : _ref4$attributes;

      var extension = (_c = (_b = (_a = url == null ? void 0 : url.split(".")) == null ? void 0 : _a.pop()) == null ? void 0 : _b.toLowerCase()) != null ? _c : "";
      var scriptElement = createElementByExtension(extension, url);

      if (!scriptElement) {
        return reject(new LoadBrowserScriptError("unsupported extension: " + extension));
      }

      Object.entries(attributes).forEach(function (_ref5) {
        var attributeName = _ref5[0],
            attributeValue = _ref5[1];
        scriptElement[attributeName] = attributeValue;
      });
      scriptElement.addEventListener("load", function () {
        return resolve({
          status: "success"
        });
      });
      scriptElement.addEventListener("error", function (err) {
        return reject(new LoadBrowserScriptError("Failed to load the script: " + err + ": " + url));
      });
      document[append].appendChild(scriptElement);
    } catch (error) {
      return reject(new LoadBrowserScriptError(error + ": " + url));
    }
  });
};

var Loop = function Loop(sequentially, files, fn) {
  return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var _iterator3, _step3, file;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!sequentially) {
              _context8.next = 9;
              break;
            }

            _iterator3 = _createForOfIteratorHelperLoose(files);

          case 2:
            if ((_step3 = _iterator3()).done) {
              _context8.next = 8;
              break;
            }

            file = _step3.value;
            _context8.next = 6;
            return fn(file);

          case 6:
            _context8.next = 2;
            break;

          case 8:
            return _context8.abrupt("return");

          case 9:
            _context8.next = 11;
            return Promise.all(files.map(function (file) {
              return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return fn(file);

                      case 2:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));
            }));

          case 11:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
};

var convertFileObjectToArray = function convertFileObjectToArray(file) {
  return [file.module, {
    component: file.component,
    default: {
      file: file.file,
      manifest: file.manifest
    }
  }];
};

var fakeLruCache = function fakeLruCache() {
  return {
    get: function get() {
      return null;
    },
    put: function put() {
      return null;
    }
  };
};

var newLruCache = function newLruCache(_ref6) {
  var _ref6$maxEntries = _ref6.maxEntries,
      maxEntries = _ref6$maxEntries === void 0 ? 10 : _ref6$maxEntries,
      _ref6$ttl = _ref6.ttl,
      ttl = _ref6$ttl === void 0 ? 1e3 : _ref6$ttl,
      _ref6$store = _ref6.store,
      store = _ref6$store === void 0 ? new Map() : _ref6$store;

  var get = function get(key) {
    var hasKey = store.has(key);

    if (!hasKey) {
      return null;
    }

    var entry = store.get(key);

    if (new Date().getTime() - entry.time.getTime() > entry.ttl) {
      store.delete(key);
      return null;
    }

    store.delete(key);
    store.set(key, entry);
    return entry.data;
  };

  var put = function put(key, value, customTtl) {
    if (customTtl === void 0) {
      customTtl = null;
    }

    if (!value) return;

    if (store.size >= maxEntries) {
      var keyToDelete = store.keys().next().value;
      store.delete(keyToDelete);
    }

    if (!customTtl) customTtl = ttl;
    store.set(key, {
      data: value,
      time: new Date(),
      ttl: customTtl
    });
  };

  return {
    get: get,
    put: put
  };
};

var createNewManifestCache = function createNewManifestCache(opts) {
  var defaultValues = {
    maxEntries: 5,
    ttl: 1e4
  };

  switch (typeof opts) {
    case "boolean":
      return opts ? newLruCache(defaultValues) : fakeLruCache();

    case "number":
      return opts > 0 ? newLruCache({
        maxEntries: defaultValues.maxEntries,
        ttl: opts
      }) : fakeLruCache();

    default:
      return newLruCache(defaultValues);
  }
};

var getCacheTime = function getCacheTime(opts, moduleName) {
  if (typeof opts === "object" && opts[moduleName] !== void 0) {
    return opts[moduleName];
  } else if (typeof opts === "object" && opts[moduleName] === void 0) {
    return true;
  }

  return opts;
};

var merge = function merge(obj, defaultObj) {
  if (defaultObj === void 0) {
    defaultObj = {};
  }

  var mergedObj = __spreadValues(__spreadValues({}, defaultObj), obj);

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (typeof obj[key] === "boolean") {
        mergedObj[key] = obj[key];
      }
    }
  }

  return mergedObj;
};

var GlobalModule = function GlobalModule(moduleName) {
  try {
    return globalThis[moduleName] || null;
  } catch (error) {
    return null;
  }
};

var LoadedGlobalComponent = function LoadedGlobalComponent(moduleName, componentName) {
  try {
    return (GlobalModule(moduleName) || {})[componentName];
  } catch (error) {
    return null;
  }
};

var AddComponentToGlobalModule = function AddComponentToGlobalModule(moduleName, componentName, fn, isSSRLegacy) {
  if (isSSRLegacy === void 0) {
    isSSRLegacy = false;
  }

  return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var _globalThis$moduleNam;

    var loadedFunction;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!isSSRLegacy) {
              _context9.next = 4;
              break;
            }

            _context9.t0 = fn;
            _context9.next = 7;
            break;

          case 4:
            _context9.next = 6;
            return fn();

          case 6:
            _context9.t0 = _context9.sent;

          case 7:
            loadedFunction = _context9.t0;

            if (!(!componentName || loadedFunction && loadedFunction.default)) {
              _context9.next = 11;
              break;
            }

            globalThis[moduleName] = loadedFunction;
            return _context9.abrupt("return");

          case 11:
            globalThis[moduleName] = (_globalThis$moduleNam = {}, _globalThis$moduleNam[componentName] = loadedFunction, _globalThis$moduleNam);

          case 12:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
};

var getPackageVersion = function getPackageVersion() {
  try {
    return "2.2.0";
  } catch (error) {
    return "unknown";
  }
};

var perf = function perf() {
  return performance && performance.now() || 0;
};

var timeMeasure = function timeMeasure(t0) {
  return !t0 || t0 < 0 ? "" : (perf() - t0).toFixed(2) + "ms";
};

var getUuid = function getUuid(length) {
  if (length === void 0) {
    length = 8;
  }

  try {
    return _toConsumableArray(Array(length)).map(function () {
      return (~~(Math.random() * 36)).toString(36);
    }).join("") || uuidv4();
  } catch (error) {
    return uuidv4();
  }
};

var uuidv4 = function uuidv4(a) {
  if (a === void 0) {
    a = "";
  }

  return a ? ((Number(a) ^ Math.random() * 16) >> Number(a) / 4).toString(16) : (1e7 + "-" + 1e3 + "-" + 4e3 + "-" + 8e3 + "-" + 1e11).replace(/[018]/g, uuidv4);
};

var FakeEmitter = function FakeEmitter() {
  return {
    all: new Map(),
    emit: function emit() {
      return null;
    },
    on: function on() {
      return null;
    },
    off: function off() {
      return null;
    }
  };
};

var ConfigValidationError = /*#__PURE__*/function (_Error5) {
  _inheritsLoose(ConfigValidationError, _Error5);

  function ConfigValidationError(msg) {
    var _this5;

    _this5 = _Error5.call(this, msg) || this;
    _this5.name = "ConfigValidationError";
    return _this5;
  }

  return ConfigValidationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ValidateGlobals = function ValidateGlobals(globals) {
  var globalsError = [];

  if (globals) {
    for (var key in globals) {
      var value = globals[key];

      if (!isFunction(value) && !(value && isString(value))) {
        globalsError.push(key);
      }
    }
  }

  if (globalsError.length > 0) return globalsError.join(", ");
};

var ConfigValidation = function ConfigValidation(_0) {
  return __async(void 0, [_0], /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref7) {
    var config, pluginManager, t0, caller;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            config = _ref7.config, pluginManager = _ref7.pluginManager;
            t0 = perf();
            caller = "config-validation";
            return _context10.abrupt("return", new Promise(function (resolve, reject) {
              pluginManager == null ? void 0 : pluginManager("onConfigValidationStart", {
                msg: "checking for valid configuration",
                config: config,
                caller: caller
              });
              var ENV = config.ENV,
                  Render = config.Render;
              if (!ENV) return reject(new ConfigValidationError("missing ENV object"));
              if (!Render || Array.isArray(Render) && Render.length === 0) pluginManager == null ? void 0 : pluginManager("onConfigValidationMessage", {
                msg: "no render libraries(s) passed in",
                console: "warn",
                caller: caller
              });
              var err = ValidateGlobals(config.globals);
              if (err) return reject(new ConfigValidationError("failed to validate the following globals: " + err));
              pluginManager == null ? void 0 : pluginManager("onConfigValidationEnd", {
                msg: "done validating configuration",
                time: timeMeasure(t0),
                caller: caller
              });
              return resolve(null);
            }));

          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
};

var LoadChunksError = /*#__PURE__*/function (_Error6) {
  _inheritsLoose(LoadChunksError, _Error6);

  function LoadChunksError(msg) {
    var _this6;

    _this6 = _Error6.call(this, msg) || this;
    _this6.name = "LoadChunksError";
    _this6.stack = msg == null ? void 0 : msg.stack;
    return _this6;
  }

  return LoadChunksError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var LoadChunks = function LoadChunks(_0) {
  return __async(void 0, [_0], /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref8) {
    var config, pluginManager, downloadManifest;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            config = _ref8.config, pluginManager = _ref8.pluginManager, downloadManifest = _ref8.downloadManifest;
            return _context13.abrupt("return", new Promise(function (resolve, reject) {
              (function () {
                return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
                  var t0, caller, _config$files, files, ENV, http;

                  return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                      switch (_context12.prev = _context12.next) {
                        case 0:
                          t0 = perf();
                          caller = "load-chunks";
                          _context12.prev = 2;
                          pluginManager == null ? void 0 : pluginManager("onLoadChunksStart", {
                            msg: "checking for chunks",
                            caller: caller
                          });
                          _config$files = config.files, files = _config$files === void 0 ? [] : _config$files, ENV = config.ENV, http = config.http;
                          _context12.next = 7;
                          return Loop(true, files, function (moduleConfig) {
                            return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                              var _ref9, moduleName, moduleFiles, _iterator4, _step4, moduleConfig2, append, ssrSkipLoad, chunks, moduleEnvConfig, onModuleError, _ref10, manifest, attributes, manifestResult, _iterator5, _step5, chunk, chunkLink, result;

                              return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                                while (1) {
                                  switch (_context11.prev = _context11.next) {
                                    case 0:
                                      _ref9 = Array.isArray(moduleConfig) ? moduleConfig : convertFileObjectToArray(moduleConfig), moduleName = _ref9[0], moduleFiles = _ref9[1];
                                      pluginManager == null ? void 0 : pluginManager("onLoadChunksMessage", {
                                        msg: "checking " + moduleName + " module for file chunks",
                                        caller: caller
                                      });
                                      _iterator4 = _createForOfIteratorHelperLoose(Array.isArray(moduleFiles) ? moduleFiles : [moduleFiles]);

                                    case 3:
                                      if ((_step4 = _iterator4()).done) {
                                        _context11.next = 44;
                                        break;
                                      }

                                      moduleConfig2 = _step4.value;
                                      append = moduleConfig2.append, ssrSkipLoad = moduleConfig2.ssrSkipLoad, chunks = moduleConfig2.chunks, moduleEnvConfig = moduleConfig2[ENV || "default"], onModuleError = moduleConfig2.onModuleError;
                                      _ref10 = moduleEnvConfig || moduleConfig2["default"] || {}, manifest = _ref10.manifest, attributes = _ref10.attributes;

                                      if (!(!chunks || chunks && (chunks == null ? void 0 : chunks.length) === 0 || !manifest)) {
                                        _context11.next = 10;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadChunksMessage", {
                                        msg: "no chunks found in " + moduleName,
                                        caller: caller
                                      });
                                      return _context11.abrupt("break", 44);

                                    case 10:
                                      if (!(isSSR() && ssrSkipLoad)) {
                                        _context11.next = 12;
                                        break;
                                      }

                                      return _context11.abrupt("break", 44);

                                    case 12:
                                      _context11.next = 14;
                                      return downloadManifest(manifest, moduleName).catch(function (err) {
                                        return err;
                                      });

                                    case 14:
                                      manifestResult = _context11.sent;

                                      if (!isError(manifestResult)) {
                                        _context11.next = 19;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadChunksError", {
                                        msg: "unable to load manifest",
                                        error: manifestResult,
                                        caller: caller
                                      });
                                      onModuleError == null ? void 0 : onModuleError({
                                        error: manifestResult
                                      });
                                      return _context11.abrupt("continue", 42);

                                    case 19:
                                      _iterator5 = _createForOfIteratorHelperLoose(chunks);

                                    case 20:
                                      if ((_step5 = _iterator5()).done) {
                                        _context11.next = 42;
                                        break;
                                      }

                                      chunk = _step5.value;

                                      if (!(isString(chunk) && manifest)) {
                                        _context11.next = 40;
                                        break;
                                      }

                                      chunkLink = manifestResult[chunk];

                                      if (!chunkLink) {
                                        _context11.next = 39;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadChunksMessage", {
                                        msg: "loading chunk: " + chunkLink,
                                        ssr: isSSR(),
                                        caller: caller
                                      });
                                      result = void 0;

                                      if (!isSSR()) {
                                        _context11.next = 33;
                                        break;
                                      }

                                      _context11.next = 30;
                                      return FetchFileAndAddToGlobal(moduleName, chunkLink, {
                                        http: http
                                      }).catch(function (err) {
                                        return err;
                                      });

                                    case 30:
                                      result = _context11.sent;
                                      _context11.next = 36;
                                      break;

                                    case 33:
                                      _context11.next = 35;
                                      return LoadBrowserScript(chunkLink, {
                                        append: append,
                                        attributes: attributes
                                      }).catch(function (err) {
                                        return err;
                                      });

                                    case 35:
                                      result = _context11.sent;

                                    case 36:
                                      if (isError(result)) {
                                        pluginManager == null ? void 0 : pluginManager("onLoadChunksError", {
                                          msg: "unable to load chunk: " + chunkLink,
                                          error: result,
                                          caller: caller
                                        });
                                        onModuleError == null ? void 0 : onModuleError({
                                          error: manifestResult
                                        });
                                      }

                                      _context11.next = 40;
                                      break;

                                    case 39:
                                      pluginManager == null ? void 0 : pluginManager("onLoadChunksMessage", {
                                        msg: "chunk: " + chunk + " was not found inside assets-manifest.json",
                                        console: "warn",
                                        caller: caller
                                      });

                                    case 40:
                                      _context11.next = 20;
                                      break;

                                    case 42:
                                      _context11.next = 3;
                                      break;

                                    case 44:
                                    case "end":
                                      return _context11.stop();
                                  }
                                }
                              }, _callee11);
                            }));
                          });

                        case 7:
                          _context12.next = 12;
                          break;

                        case 9:
                          _context12.prev = 9;
                          _context12.t0 = _context12["catch"](2);
                          return _context12.abrupt("return", reject(new LoadChunksError(_context12.t0)));

                        case 12:
                          pluginManager == null ? void 0 : pluginManager("onLoadChunksEnd", {
                            msg: "done loading chunks",
                            time: timeMeasure(t0),
                            caller: caller
                          });
                          return _context12.abrupt("return", resolve(null));

                        case 14:
                        case "end":
                          return _context12.stop();
                      }
                    }
                  }, _callee12, null, [[2, 9]]);
                }));
              })();
            }));

          case 2:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
};

var LoadGlobalFilesError = /*#__PURE__*/function (_Error7) {
  _inheritsLoose(LoadGlobalFilesError, _Error7);

  function LoadGlobalFilesError(msg) {
    var _this7;

    _this7 = _Error7.call(this, msg) || this;
    _this7.name = "LoadGlobalFilesError";
    _this7.stack = msg == null ? void 0 : msg.stack;
    return _this7;
  }

  return LoadGlobalFilesError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var LoadGlobalFiles = function LoadGlobalFiles(_0) {
  return __async(void 0, [_0], /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref11) {
    var config, pluginManager;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            config = _ref11.config, pluginManager = _ref11.pluginManager;
            return _context15.abrupt("return", new Promise(function (resolve, reject) {
              (function () {
                return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
                  var t0, caller, globals, http, key, value, result;
                  return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          t0 = perf();
                          caller = "load-global-files";
                          _context14.prev = 2;
                          pluginManager == null ? void 0 : pluginManager("onLoadGlobalFilesStart", {
                            msg: "checking for global files",
                            caller: caller
                          });
                          globals = config.globals, http = config.http;
                          _context14.t0 = _regeneratorRuntime.keys(globals);

                        case 6:
                          if ((_context14.t1 = _context14.t0()).done) {
                            _context14.next = 35;
                            break;
                          }

                          key = _context14.t1.value;
                          value = globals[key];

                          if (!GlobalModule(key)) {
                            _context14.next = 12;
                            break;
                          }

                          pluginManager == null ? void 0 : pluginManager("onLoadGlobalFilesMessage", {
                            msg: key + " has been previously loaded, skipping",
                            caller: caller
                          });
                          return _context14.abrupt("continue", 6);

                        case 12:
                          if (!isString(value)) {
                            _context14.next = 26;
                            break;
                          }

                          result = void 0;

                          if (!isSSR()) {
                            _context14.next = 20;
                            break;
                          }

                          _context14.next = 17;
                          return FetchFileAndAddToGlobal(key, value, {
                            http: http
                          }).catch(function (err) {
                            return err;
                          });

                        case 17:
                          result = _context14.sent;
                          _context14.next = 23;
                          break;

                        case 20:
                          _context14.next = 22;
                          return LoadBrowserScript(value).catch(function (err) {
                            return err;
                          });

                        case 22:
                          result = _context14.sent;

                        case 23:
                          if (isError(result)) {
                            pluginManager == null ? void 0 : pluginManager("onLoadGlobalFilesError", {
                              msg: "unable to load global",
                              error: result,
                              caller: caller
                            });
                          }

                          _context14.next = 32;
                          break;

                        case 26:
                          if (!isFunction(value)) {
                            _context14.next = 31;
                            break;
                          }

                          _context14.next = 29;
                          return AddComponentToGlobalModule(key, null, value);

                        case 29:
                          _context14.next = 32;
                          break;

                        case 31:
                          pluginManager == null ? void 0 : pluginManager("onLoadGlobalFilesMessage", {
                            msg: "unable to determine " + key + " type.",
                            caller: caller
                          });

                        case 32:
                          if (GlobalModule(key)) {
                            pluginManager == null ? void 0 : pluginManager("onLoadGlobalFilesMessage", {
                              msg: key + " has been loaded to global scope",
                              caller: caller
                            });
                          }

                          _context14.next = 6;
                          break;

                        case 35:
                          _context14.next = 40;
                          break;

                        case 37:
                          _context14.prev = 37;
                          _context14.t2 = _context14["catch"](2);
                          return _context14.abrupt("return", reject(new LoadGlobalFilesError(_context14.t2)));

                        case 40:
                          pluginManager == null ? void 0 : pluginManager("onLoadGlobalFilesEnd", {
                            msg: "done loading global files",
                            time: timeMeasure(t0),
                            caller: caller
                          });
                          return _context14.abrupt("return", resolve(null));

                        case 42:
                        case "end":
                          return _context14.stop();
                      }
                    }
                  }, _callee14, null, [[2, 37]]);
                }));
              })();
            }));

          case 2:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
};

var LoadMainFilesError = /*#__PURE__*/function (_Error8) {
  _inheritsLoose(LoadMainFilesError, _Error8);

  function LoadMainFilesError(msg) {
    var _this8;

    _this8 = _Error8.call(this, msg) || this;
    _this8.name = "LoadMainFilesError";
    _this8.stack = msg == null ? void 0 : msg.stack;
    return _this8;
  }

  return LoadMainFilesError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var EmitLoadedComponentModule = function EmitLoadedComponentModule(_ref12) {
  var emitter = _ref12.emitter,
      pluginManager = _ref12.pluginManager;
  return function (_ref13) {
    var moduleName = _ref13.moduleName,
        componentsToLoadFromModule = _ref13.componentsToLoadFromModule,
        moduleTimeStart = _ref13.moduleTimeStart,
        fileToLoad = _ref13.fileToLoad;

    for (var _iterator6 = _createForOfIteratorHelperLoose(componentsToLoadFromModule), _step6; !(_step6 = _iterator6()).done;) {
      var componentName = _step6.value;
      var hasComponentBeenLoadedInGlobalWindow = !!LoadedGlobalComponent(moduleName, componentName);

      if (!hasComponentBeenLoadedInGlobalWindow) {
        pluginManager == null ? void 0 : pluginManager("onLoadMainFilesMessage", {
          msg: componentName + " is missing from globally loaded " + moduleName + ". try doing a refresh to re-download module or check for errors.",
          console: "warn",
          caller: "load-main-files"
        });
        return;
      }

      pluginManager == null ? void 0 : pluginManager("onLoadMainFilesMessage", {
        msg: moduleName + "." + componentName + " has been loaded",
        caller: "load-main-files",
        moduleName: moduleName,
        componentName: componentName,
        type: "module-loaded",
        moduleLoadTime: timeMeasure(moduleTimeStart),
        url: fileToLoad
      });
      emitter == null ? void 0 : emitter.emit(moduleName + "-" + componentName, {
        moduleName: moduleName,
        componentName: componentName
      });
    }
  };
};

var LoadMainFiles = function LoadMainFiles(_0) {
  return __async(void 0, [_0], /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref14) {
    var config, emitter, _ref14$opts$loadMainF, loadMainFilesSequentially, pluginManager, manifestCache2, downloadManifest;

    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            config = _ref14.config, emitter = _ref14.emitter, _ref14$opts$loadMainF = _ref14.opts.loadMainFilesSequentially, loadMainFilesSequentially = _ref14$opts$loadMainF === void 0 ? true : _ref14$opts$loadMainF, pluginManager = _ref14.pluginManager, manifestCache2 = _ref14.manifestCache, downloadManifest = _ref14.downloadManifest;
            return _context18.abrupt("return", new Promise(function (resolve, reject) {
              (function () {
                return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
                  var t0, caller, _config$files2, files, ENV, http, cacheManifest, emitModuleLoaded;

                  return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                      switch (_context17.prev = _context17.next) {
                        case 0:
                          t0 = perf();
                          caller = "load-main-files";
                          _context17.prev = 2;
                          pluginManager == null ? void 0 : pluginManager("onLoadMainFilesStart", {
                            msg: "loading main files",
                            sequentially: loadMainFilesSequentially,
                            caller: caller
                          });
                          _config$files2 = config.files, files = _config$files2 === void 0 ? [] : _config$files2, ENV = config.ENV, http = config.http, cacheManifest = config.cacheManifest;
                          emitModuleLoaded = EmitLoadedComponentModule({
                            emitter: emitter,
                            pluginManager: pluginManager
                          });
                          _context17.next = 8;
                          return Loop(loadMainFilesSequentially, files, function (moduleConfig) {
                            return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
                              var _ref15, moduleName, moduleFiles, _iterator7, _step7, moduleConfig2, component, ssrSkipLoad, ssrLegacy, browser, append, onModuleError, _ref16, file, attributes, manifest, ssr, componentsToLoadFromModule, cacheTime, shouldCache, hasManifestCache, isSSRLegacy, fileToLoad, moduleTimeStart, manifestJsonFile, browserScript, fileAndAddToGlobal;

                              return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                                while (1) {
                                  switch (_context16.prev = _context16.next) {
                                    case 0:
                                      _context16.prev = 0;
                                      _ref15 = Array.isArray(moduleConfig) ? moduleConfig : convertFileObjectToArray(moduleConfig), moduleName = _ref15[0], moduleFiles = _ref15[1];
                                      _iterator7 = _createForOfIteratorHelperLoose(Array.isArray(moduleFiles) ? moduleFiles : [moduleFiles]);

                                    case 3:
                                      if ((_step7 = _iterator7()).done) {
                                        _context16.next = 63;
                                        break;
                                      }

                                      moduleConfig2 = _step7.value;
                                      component = moduleConfig2.component, ssrSkipLoad = moduleConfig2.ssrSkipLoad, ssrLegacy = moduleConfig2.ssrLegacy, browser = moduleConfig2.browser, append = moduleConfig2.append, onModuleError = moduleConfig2.onModuleError;
                                      _ref16 = moduleConfig2[ENV] || moduleConfig2["default"] || {}, file = _ref16.file, attributes = _ref16.attributes, manifest = _ref16.manifest, ssr = _ref16.ssr;

                                      if (!(!file || !manifest && !file)) {
                                        _context16.next = 9;
                                        break;
                                      }

                                      return _context16.abrupt("continue", 61);

                                    case 9:
                                      if (!(ssrSkipLoad && isSSR())) {
                                        _context16.next = 12;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadMainFilesMessage", {
                                        msg: "skipping module loading in ssr",
                                        moduleName: moduleName,
                                        caller: caller
                                      });
                                      return _context16.abrupt("continue", 61);

                                    case 12:
                                      componentsToLoadFromModule = Array.isArray(component) ? component : [component];
                                      cacheTime = getCacheTime(cacheManifest, moduleName);
                                      shouldCache = cacheTime !== void 0 || cacheTime || typeof cacheTime === "number" && cacheTime > 0;
                                      hasManifestCache = shouldCache && manifest && !!manifestCache2.get(manifest);

                                      if (!(hasManifestCache && GlobalModule(moduleName))) {
                                        _context16.next = 20;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadMainFilesMessage", {
                                        msg: moduleName + " has been previously loaded, skipping.",
                                        caller: caller
                                      });
                                      emitModuleLoaded({
                                        moduleName: moduleName,
                                        componentsToLoadFromModule: componentsToLoadFromModule,
                                        moduleTimeStart: 0,
                                        fileToLoad: ""
                                      });
                                      return _context16.abrupt("continue", 61);

                                    case 20:
                                      isSSRLegacy = isSSR() && (ssr || ssrLegacy);
                                      fileToLoad = isSSRLegacy || file;
                                      moduleTimeStart = perf();

                                      if (!isFunction(fileToLoad)) {
                                        _context16.next = 29;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadMainFilesMessage", {
                                        msg: "loading module " + moduleName + " from function",
                                        isSSR: isSSR(),
                                        ssrLegacy: isSSRLegacy,
                                        caller: caller
                                      });
                                      _context16.next = 27;
                                      return AddComponentToGlobalModule(moduleName, componentsToLoadFromModule[0], fileToLoad, !!isSSRLegacy);

                                    case 27:
                                      _context16.next = 60;
                                      break;

                                    case 29:
                                      if (!manifest) {
                                        _context16.next = 38;
                                        break;
                                      }

                                      _context16.next = 32;
                                      return downloadManifest(manifest, moduleName, cacheTime).catch(function (err) {
                                        return err;
                                      });

                                    case 32:
                                      manifestJsonFile = _context16.sent;

                                      if (!isError(manifestJsonFile)) {
                                        _context16.next = 37;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadMainFilesError", {
                                        msg: "unable to load manifest",
                                        manifest: manifest,
                                        error: manifestJsonFile,
                                        caller: caller
                                      });
                                      onModuleError == null ? void 0 : onModuleError({
                                        error: manifestJsonFile
                                      });
                                      return _context16.abrupt("continue", 61);

                                    case 37:
                                      fileToLoad = manifestJsonFile[file];

                                    case 38:
                                      if (!(isString(fileToLoad) && isHTTPURL(fileToLoad))) {
                                        _context16.next = 60;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadMainFilesMessage", {
                                        msg: "fetching module: " + moduleName + " from " + fileToLoad,
                                        isSSR: isSSR(),
                                        browser: browser,
                                        caller: caller
                                      });

                                      if (!browser) {
                                        _context16.next = 53;
                                        break;
                                      }

                                      if (!isSSR()) {
                                        _context16.next = 44;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadMainFilesMessage", {
                                        msg: "cannot load browser module in ssr, skipping...",
                                        fileToLoad: fileToLoad,
                                        caller: caller
                                      });
                                      return _context16.abrupt("continue", 61);

                                    case 44:
                                      _context16.next = 46;
                                      return LoadBrowserScript(fileToLoad, {
                                        append: append,
                                        attributes: attributes
                                      }).catch(function (err) {
                                        return err;
                                      });

                                    case 46:
                                      browserScript = _context16.sent;

                                      if (!isError(browserScript)) {
                                        _context16.next = 51;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadMainFilesError", {
                                        msg: "unable to load module through browser",
                                        fileToLoad: fileToLoad,
                                        error: browserScript,
                                        caller: caller
                                      });
                                      onModuleError == null ? void 0 : onModuleError({
                                        error: browserScript
                                      });
                                      return _context16.abrupt("continue", 61);

                                    case 51:
                                      _context16.next = 60;
                                      break;

                                    case 53:
                                      _context16.next = 55;
                                      return FetchFileAndAddToGlobal(moduleName, fileToLoad, {
                                        http: http
                                      }).catch(function (err) {
                                        return err;
                                      });

                                    case 55:
                                      fileAndAddToGlobal = _context16.sent;

                                      if (!isError(fileAndAddToGlobal)) {
                                        _context16.next = 60;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadMainFilesError", {
                                        msg: "unable to download module and add to global",
                                        fileToLoad: fileToLoad,
                                        error: fileAndAddToGlobal,
                                        caller: caller
                                      });
                                      onModuleError == null ? void 0 : onModuleError({
                                        error: fileAndAddToGlobal
                                      });
                                      return _context16.abrupt("continue", 61);

                                    case 60:
                                      emitModuleLoaded({
                                        moduleName: moduleName,
                                        componentsToLoadFromModule: componentsToLoadFromModule,
                                        moduleTimeStart: moduleTimeStart,
                                        fileToLoad: fileToLoad && isString(fileToLoad) ? fileToLoad : ""
                                      });

                                    case 61:
                                      _context16.next = 3;
                                      break;

                                    case 63:
                                      _context16.next = 68;
                                      break;

                                    case 65:
                                      _context16.prev = 65;
                                      _context16.t0 = _context16["catch"](0);
                                      pluginManager == null ? void 0 : pluginManager("onLoadMainFilesError", {
                                        msg: "failed to load main file",
                                        error: _context16.t0,
                                        caller: caller
                                      });

                                    case 68:
                                    case "end":
                                      return _context16.stop();
                                  }
                                }
                              }, _callee16, null, [[0, 65]]);
                            }));
                          });

                        case 8:
                          _context17.next = 13;
                          break;

                        case 10:
                          _context17.prev = 10;
                          _context17.t0 = _context17["catch"](2);
                          return _context17.abrupt("return", reject(new LoadMainFilesError(_context17.t0)));

                        case 13:
                          pluginManager == null ? void 0 : pluginManager("onLoadMainFilesEnd", {
                            msg: "done loading main files",
                            time: timeMeasure(t0),
                            caller: caller
                          });
                          return _context17.abrupt("return", resolve(null));

                        case 15:
                        case "end":
                          return _context17.stop();
                      }
                    }
                  }, _callee17, null, [[2, 10]]);
                }));
              })();
            }));

          case 2:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
};

var PreloadHighPriorityFilesError = /*#__PURE__*/function (_Error9) {
  _inheritsLoose(PreloadHighPriorityFilesError, _Error9);

  function PreloadHighPriorityFilesError(msg) {
    var _this9;

    _this9 = _Error9.call(this, msg) || this;
    _this9.name = "PreloadHighPriorityFilesError";
    _this9.stack = msg == null ? void 0 : msg.stack;
    return _this9;
  }

  return PreloadHighPriorityFilesError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var appendPreLoadLink = function appendPreLoadLink(url, linkCrossOrigin) {
  return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.prev = 0;
            return _context19.abrupt("return", new Promise(function (resolve) {
              if (document) {
                var script = document.createElement("link");
                script.href = url;
                script.as = "script";
                script.rel = "preload";
                if (linkCrossOrigin) script.crossOrigin = linkCrossOrigin;
                document.getElementsByTagName("head")[0].appendChild(script);
              }

              return resolve();
            }));

          case 4:
            _context19.prev = 4;
            _context19.t0 = _context19["catch"](0);
            throw new PreloadHighPriorityFilesError(_context19.t0);

          case 7:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, null, [[0, 4]]);
  }));
};

var PreloadHighPriorityFiles = function PreloadHighPriorityFiles(_0) {
  return __async(void 0, [_0], /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_ref17) {
    var config, pluginManager, downloadManifest;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            config = _ref17.config, pluginManager = _ref17.pluginManager, downloadManifest = _ref17.downloadManifest;
            return _context22.abrupt("return", new Promise(function (resolve, reject) {
              if (isSSR()) return resolve(null);

              (function () {
                return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
                  var t0, caller, _config$files3, files, ENV;

                  return _regeneratorRuntime.wrap(function _callee21$(_context21) {
                    while (1) {
                      switch (_context21.prev = _context21.next) {
                        case 0:
                          t0 = perf();
                          caller = "preload-high-priority";
                          _context21.prev = 2;
                          _config$files3 = config.files, files = _config$files3 === void 0 ? [] : _config$files3, ENV = config.ENV;
                          _context21.next = 6;
                          return Loop(true, files, function (moduleConfig) {
                            return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
                              var _ref18, moduleName, moduleFiles, _iterator8, _step8, moduleConfig2, priority, linkCrossOrigin, moduleEnvConfig, onModuleError, _ref19, manifest, file, manifestResult, link;

                              return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                                while (1) {
                                  switch (_context20.prev = _context20.next) {
                                    case 0:
                                      _ref18 = Array.isArray(moduleConfig) ? moduleConfig : convertFileObjectToArray(moduleConfig), moduleName = _ref18[0], moduleFiles = _ref18[1];
                                      pluginManager == null ? void 0 : pluginManager("onPreLoadHighPriorityFilesStart", {
                                        msg: "checking " + moduleName + " module for high priority component",
                                        caller: caller
                                      });
                                      _iterator8 = _createForOfIteratorHelperLoose(Array.isArray(moduleFiles) ? moduleFiles : [moduleFiles]);

                                    case 3:
                                      if ((_step8 = _iterator8()).done) {
                                        _context20.next = 31;
                                        break;
                                      }

                                      moduleConfig2 = _step8.value;
                                      priority = moduleConfig2.priority, linkCrossOrigin = moduleConfig2.linkCrossOrigin, moduleEnvConfig = moduleConfig2[ENV || "default"], onModuleError = moduleConfig2.onModuleError;

                                      if (!(priority === "high")) {
                                        _context20.next = 28;
                                        break;
                                      }

                                      _ref19 = moduleEnvConfig || moduleConfig2["default"] || {}, manifest = _ref19.manifest, file = _ref19.file;

                                      if (!(file && !manifest)) {
                                        _context20.next = 14;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onPreLoadHighPriorityFilesMessage", {
                                        msg: "preloading " + file + " from " + moduleName,
                                        caller: caller
                                      });
                                      _context20.next = 12;
                                      return appendPreLoadLink(file, linkCrossOrigin);

                                    case 12:
                                      _context20.next = 26;
                                      break;

                                    case 14:
                                      if (!(file && manifest)) {
                                        _context20.next = 26;
                                        break;
                                      }

                                      _context20.next = 17;
                                      return downloadManifest(manifest, moduleName).catch(function (err) {
                                        return err;
                                      });

                                    case 17:
                                      manifestResult = _context20.sent;

                                      if (!isError(manifestResult)) {
                                        _context20.next = 22;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onPreLoadHighPriorityFilesError", {
                                        msg: "unable to load manifest file",
                                        error: manifestResult,
                                        caller: caller
                                      });
                                      onModuleError == null ? void 0 : onModuleError({
                                        error: manifestResult
                                      });
                                      return _context20.abrupt("continue", 29);

                                    case 22:
                                      link = manifestResult[file];
                                      pluginManager == null ? void 0 : pluginManager("onPreLoadHighPriorityFilesMessage", {
                                        msg: "preloading " + link + " from " + moduleName,
                                        caller: caller
                                      });
                                      _context20.next = 26;
                                      return appendPreLoadLink(link, linkCrossOrigin);

                                    case 26:
                                      _context20.next = 29;
                                      break;

                                    case 28:
                                      pluginManager == null ? void 0 : pluginManager("onPreLoadHighPriorityFilesMessage", {
                                        msg: "no high priority files found in " + moduleName,
                                        caller: caller
                                      });

                                    case 29:
                                      _context20.next = 3;
                                      break;

                                    case 31:
                                    case "end":
                                      return _context20.stop();
                                  }
                                }
                              }, _callee20);
                            }));
                          });

                        case 6:
                          _context21.next = 11;
                          break;

                        case 8:
                          _context21.prev = 8;
                          _context21.t0 = _context21["catch"](2);
                          return _context21.abrupt("return", reject(new PreloadHighPriorityFilesError(_context21.t0)));

                        case 11:
                          pluginManager == null ? void 0 : pluginManager("onPreLoadHighPriorityFilesEnd", {
                            msg: "completed high priority preload of files",
                            time: timeMeasure(t0),
                            caller: caller
                          });
                          return _context21.abrupt("return", resolve(null));

                        case 13:
                        case "end":
                          return _context21.stop();
                      }
                    }
                  }, _callee21, null, [[2, 8]]);
                }));
              })();
            }));

          case 2:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
};

var RenderingEngineError = /*#__PURE__*/function (_Error10) {
  _inheritsLoose(RenderingEngineError, _Error10);

  function RenderingEngineError(msg) {
    var _this10;

    _this10 = _Error10.call(this, msg) || this;
    _this10.name = "RenderEngineError";
    _this10.stack = msg == null ? void 0 : msg.stack;
    return _this10;
  }

  return RenderingEngineError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RenderingEngine = function RenderingEngine(props) {
  return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            return _context23.abrupt("return", new Promise(function (resolve, reject) {
              var t0 = performance.now();
              var config = props.config,
                  pluginManager = props.pluginManager;
              var caller = "rendering-engine";
              pluginManager == null ? void 0 : pluginManager("onRenderingEngineStart", {
                msg: "loading rendering engines",
                caller: caller
              });
              var Render = config.Render;
              if (!Render || Array.isArray(Render) && Render.length === 0) return resolve(null);
              (Array.isArray(Render) ? Render : [Render]).forEach(function (Renderer) {
                var _a;

                try {
                  var renderName = Renderer.name || (((_a = Renderer == null ? void 0 : Renderer.toString()) == null ? void 0 : _a.match(/ (\w+)/)) || [])[1];
                  pluginManager == null ? void 0 : pluginManager("onRenderingEngineMessage", {
                    msg: "loading " + renderName + " renderer",
                    caller: caller
                  });
                  Renderer.init(props);
                } catch (error) {
                  return reject(new RenderingEngineError(error));
                }
              });
              pluginManager == null ? void 0 : pluginManager("onRenderingEngineEnd", {
                msg: "finished loading rendering engines",
                time: timeMeasure(t0),
                caller: caller
              });
              return resolve(null);
            }));

          case 1:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
};

var MfeInternalConfig = new Proxy({
  emitter: null,
  config: null,
  id: null,
  opts: null,
  pluginManager: null,
  manifestCache: null,
  downloadManifest: null
}, {});

var LoadCSSError = /*#__PURE__*/function (_Error11) {
  _inheritsLoose(LoadCSSError, _Error11);

  function LoadCSSError(msg) {
    var _this11;

    _this11 = _Error11.call(this, msg) || this;
    _this11.name = "LoadCSSError";
    _this11.stack = msg == null ? void 0 : msg.stack;
    return _this11;
  }

  return LoadCSSError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var LoadCSS = function LoadCSS(_0) {
  return __async(void 0, [_0], /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(_ref20) {
    var config, pluginManager, downloadManifest;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            config = _ref20.config, pluginManager = _ref20.pluginManager, downloadManifest = _ref20.downloadManifest;
            return _context26.abrupt("return", new Promise(function (resolve, reject) {
              if (isSSR()) return resolve(null);

              (function () {
                return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
                  var t0, caller, _config$files4, files, ENV, http;

                  return _regeneratorRuntime.wrap(function _callee25$(_context25) {
                    while (1) {
                      switch (_context25.prev = _context25.next) {
                        case 0:
                          t0 = perf();
                          caller = "load css";
                          _context25.prev = 2;
                          pluginManager == null ? void 0 : pluginManager("onLoadCssStart", {
                            msg: "checking for css",
                            caller: caller
                          });
                          _config$files4 = config.files, files = _config$files4 === void 0 ? [] : _config$files4, ENV = config.ENV, http = config.http;
                          _context25.next = 7;
                          return Loop(true, files, function (moduleConfig) {
                            return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
                              var _a, _ref21, moduleName, moduleFiles, _iterator9, _step9, moduleConfig2, append, css, moduleEnvConfig, onModuleError, _ref22, manifest, attributes, manifestResult, _iterator10, _step10, cssFile, cssLink, result, textFile, style;

                              return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                                while (1) {
                                  switch (_context24.prev = _context24.next) {
                                    case 0:
                                      _ref21 = Array.isArray(moduleConfig) ? moduleConfig : convertFileObjectToArray(moduleConfig), moduleName = _ref21[0], moduleFiles = _ref21[1];
                                      pluginManager == null ? void 0 : pluginManager("onLoadCssMessage", {
                                        msg: "checking " + moduleName + " module for css",
                                        caller: caller
                                      });
                                      _iterator9 = _createForOfIteratorHelperLoose(Array.isArray(moduleFiles) ? moduleFiles : [moduleFiles]);

                                    case 3:
                                      if ((_step9 = _iterator9()).done) {
                                        _context24.next = 45;
                                        break;
                                      }

                                      moduleConfig2 = _step9.value;
                                      append = moduleConfig2.append, css = moduleConfig2.css, moduleEnvConfig = moduleConfig2[ENV || "default"], onModuleError = moduleConfig2.onModuleError;
                                      _ref22 = moduleEnvConfig || moduleConfig2["default"] || {}, manifest = _ref22.manifest, attributes = _ref22.attributes;

                                      if (!(!css || css.files.length === 0 || !manifest)) {
                                        _context24.next = 9;
                                        break;
                                      }

                                      return _context24.abrupt("break", 45);

                                    case 9:
                                      _context24.next = 11;
                                      return downloadManifest(manifest, moduleName).catch(function (err) {
                                        return err;
                                      });

                                    case 11:
                                      manifestResult = _context24.sent;

                                      if (!isError(manifestResult)) {
                                        _context24.next = 16;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadCssError", {
                                        msg: "unable to load manifest",
                                        error: manifestResult,
                                        caller: caller
                                      });
                                      onModuleError == null ? void 0 : onModuleError({
                                        error: manifestResult
                                      });
                                      return _context24.abrupt("continue", 43);

                                    case 16:
                                      _iterator10 = _createForOfIteratorHelperLoose((css == null ? void 0 : css.files) || []);

                                    case 17:
                                      if ((_step10 = _iterator10()).done) {
                                        _context24.next = 43;
                                        break;
                                      }

                                      cssFile = _step10.value;

                                      if (!(isString(cssFile) && manifest)) {
                                        _context24.next = 41;
                                        break;
                                      }

                                      cssLink = manifestResult[cssFile];

                                      if (!cssLink) {
                                        _context24.next = 40;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadCssMessage", {
                                        msg: "loading css " + cssLink,
                                        scoped: css.scoped,
                                        caller: caller
                                      });
                                      result = void 0;

                                      if (!css.scoped) {
                                        _context24.next = 34;
                                        break;
                                      }

                                      _context24.next = 27;
                                      return DownloadFile(cssLink, "text", {
                                        http: http
                                      }).catch(function (err) {
                                        return err;
                                      });

                                    case 27:
                                      textFile = _context24.sent;

                                      if (!(isError(textFile) || !isString(textFile))) {
                                        _context24.next = 31;
                                        break;
                                      }

                                      pluginManager == null ? void 0 : pluginManager("onLoadCssError", {
                                        msg: "unknown css type for: " + cssLink,
                                        error: textFile,
                                        caller: caller
                                      });
                                      return _context24.abrupt("continue", 41);

                                    case 31:
                                      if (textFile) {
                                        style = document.createElement("style");
                                        style.id = "mfer-" + moduleName + "-" + moduleConfig2.component + "-css-scope";
                                        style.innerHTML = "#" + ("mfer-" + moduleName + "-" + moduleConfig2.component) + ", " + textFile;
                                        (_a = document.getElementById("mfer-" + moduleName + "-" + moduleConfig2.component)) == null ? void 0 : _a.append(style);
                                      }

                                      _context24.next = 37;
                                      break;

                                    case 34:
                                      _context24.next = 36;
                                      return LoadBrowserScript(cssLink, {
                                        append: append,
                                        attributes: attributes
                                      }).catch(function (err) {
                                        return err;
                                      });

                                    case 36:
                                      result = _context24.sent;

                                    case 37:
                                      if (isError(result)) {
                                        pluginManager == null ? void 0 : pluginManager("onLoadCssError", {
                                          msg: "unable to load css: " + cssLink,
                                          error: result,
                                          caller: caller
                                        });
                                        onModuleError == null ? void 0 : onModuleError({
                                          error: manifestResult
                                        });
                                      }

                                      _context24.next = 41;
                                      break;

                                    case 40:
                                      pluginManager == null ? void 0 : pluginManager("onLoadCssMessage", {
                                        msg: "css " + cssFile + " was not found inside assets-manifest.json",
                                        console: "warn",
                                        caller: caller
                                      });

                                    case 41:
                                      _context24.next = 17;
                                      break;

                                    case 43:
                                      _context24.next = 3;
                                      break;

                                    case 45:
                                    case "end":
                                      return _context24.stop();
                                  }
                                }
                              }, _callee24);
                            }));
                          });

                        case 7:
                          _context25.next = 12;
                          break;

                        case 9:
                          _context25.prev = 9;
                          _context25.t0 = _context25["catch"](2);
                          return _context25.abrupt("return", reject(new LoadCSSError(_context25.t0)));

                        case 12:
                          pluginManager == null ? void 0 : pluginManager("onLoadCssEnd", {
                            msg: "done loading css",
                            time: timeMeasure(t0),
                            caller: caller
                          });
                          return _context25.abrupt("return", resolve(null));

                        case 14:
                        case "end":
                          return _context25.stop();
                      }
                    }
                  }, _callee25, null, [[2, 9]]);
                }));
              })();
            }));

          case 2:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));
};

var PluginManager = function PluginManager(pm) {
  if (isSSR() && pm && pm._plugins.length > 0) {
    pm._plugins = pm._plugins.filter(function (plugin) {
      return plugin.runInSSR;
    });
  }

  return function (fncName) {
    if (!pm || pm._plugins.length === 0) return;

    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    for (var _iterator11 = _createForOfIteratorHelperLoose(pm._plugins), _step11; !(_step11 = _iterator11()).done;) {
      var plugin = _step11.value;

      if (plugin[fncName] && isFunction(plugin[fncName])) {
        var fnc = plugin[fncName];
        fnc.apply(void 0, args);
      }
    }
  };
};

var _PluginInstance = /*#__PURE__*/function () {
  function _PluginInstance(plugins, props) {
    __publicField(this, "_plugins", []);

    for (var _iterator12 = _createForOfIteratorHelperLoose(plugins), _step12; !(_step12 = _iterator12()).done;) {
      var plugin = _step12.value;
      if (plugin) this._plugins.push(plugin(props));
    }
  }

  _PluginInstance.getInstance = function getInstance(plugins, props) {
    if (isSSR() || plugins.length === 0) return;

    if (!_PluginInstance.instance) {
      _PluginInstance.instance = new _PluginInstance(plugins, props);
    }

    return _PluginInstance.instance;
  };

  _PluginInstance.resetInstance = function resetInstance() {
    _PluginInstance.instance = void 0;
  };

  return _PluginInstance;
}();

__publicField(_PluginInstance, "instance");

var PluginInstance = _PluginInstance;
var manifestCache;

var ManifestCacheManager = function ManifestCacheManager(cacheManifest) {
  manifestCache = manifestCache || createNewManifestCache(cacheManifest);
  return manifestCache;
};

var consoleLogger = function consoleLogger(name, type) {
  if (type === void 0) {
    type = "log";
  }

  return console[type].bind(console, "%c [mfe-" + name + "]:", "color: rgb(0,174,217); font-weight: bold;");
};

var LoggerPlugin = function LoggerPlugin() {
  return function (props) {
    var env = props.env,
        fncType = props.fncType,
        id = props.id,
        callerName = props.name,
        debug = props.debug;
    var pluginName = "logger";
    var pluginVersion = "1.0.0";

    var log = function log(_a) {
      var _b = _a,
          caller = _b.caller,
          msg = _b.msg,
          console2 = _b.console,
          rest = __objRest(_b, ["caller", "msg", "console"]);

      if (!debug || env === "production" || env === "prod") return;
      var hasError = rest == null ? void 0 : rest.error;
      var consoleLogType = hasError ? "error" : console2 || "log";
      var args = rest && Object.keys(rest).length > 0 ? __spreadValues({
        fncType: fncType
      }, rest || {}) : "";
      consoleLogger(caller, consoleLogType)(msg, args, "[" + callerName + "(" + id + ")]");
    };

    return {
      name: pluginName,
      version: pluginVersion,
      runInSSR: true,
      onStart: log,
      onEnd: log,
      onMessage: log,
      onError: log,
      onConfigValidationStart: log,
      onConfigValidationEnd: log,
      onConfigValidationMessage: log,
      onConfigValidationError: log,
      onRenderingEngineStart: log,
      onRenderingEngineEnd: log,
      onRenderingEngineMessage: log,
      onRenderingEngineError: log,
      onPreLoadHighPriorityFilesStart: log,
      onPreLoadHighPriorityFilesEnd: log,
      onPreLoadHighPriorityFilesMessage: log,
      onPreLoadHighPriorityFilesError: log,
      onLoadChunksStart: log,
      onLoadChunksEnd: log,
      onLoadChunksMessage: log,
      onLoadChunksError: log,
      onLoadGlobalFilesStart: log,
      onLoadGlobalFilesEnd: log,
      onLoadGlobalFilesMessage: log,
      onLoadGlobalFilesError: log,
      onLoadCssStart: log,
      onLoadCssEnd: log,
      onLoadCssMessage: log,
      onLoadCssError: log,
      onLoadMainFilesStart: log,
      onLoadMainFilesEnd: log,
      onLoadMainFilesMessage: log,
      onLoadMainFilesError: log,
      onComponentError: log,
      onComponentMessage: log
    };
  };
};

var InternalConfig = function InternalConfig(config) {
  MfeInternalConfig.config = config.config;
  MfeInternalConfig.emitter = config.emitter;
  MfeInternalConfig.error = config.error;
  MfeInternalConfig.id = config.id;
  MfeInternalConfig.opts = config.opts;
  MfeInternalConfig.pluginManager = config.pluginManager;
  MfeInternalConfig.manifestCache = config.manifestCache;
  MfeInternalConfig.downloadManifest = config.downloadManifest;
  return MfeInternalConfig;
};

var mfeLoadQueue = [];
var isMferLoaded = false;
var isFirstRun = true;
var Plugins = [LoggerPlugin()];

var MicrofrontEndConfig = function MicrofrontEndConfig(config, opts, isMfeLoad, addToQueue) {
  return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            return _context28.abrupt("return", new Promise(function (resolve, reject) {
              (function () {
                return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
                  var t0, instanceId, caller, emitter, logName, version, pluginManager, manifestCache2, downloadManifest, internalConfig, _ref23, skipValidation, skipPreload, skipGlobals, skipChunks, skipLoadCSS;

                  return _regeneratorRuntime.wrap(function _callee27$(_context27) {
                    while (1) {
                      switch (_context27.prev = _context27.next) {
                        case 0:
                          t0 = perf();
                          instanceId = (opts == null ? void 0 : opts.id) || getUuid();
                          caller = "config";
                          emitter = isSSR() && FakeEmitter() || config.emitter || mitt();
                          logName = isMfeLoad && "mfeload" || "mfeconfig";
                          if (opts.plugins && opts.plugins.length > 0 && isFirstRun) Plugins = [].concat(_toConsumableArray(Plugins), _toConsumableArray(opts.plugins));
                          version = getPackageVersion();
                          if (isMfeLoad) PluginInstance.resetInstance();

                          if (!(!isSSR() && ((opts == null ? void 0 : opts.useQueueForInitialMfeLoad) && !isMferLoaded && isFirstRun && isMfeLoad || addToQueue))) {
                            _context27.next = 11;
                            break;
                          }

                          mfeLoadQueue.push(config);
                          return _context27.abrupt("return");

                        case 11:
                          pluginManager = PluginManager(PluginInstance.getInstance(Plugins, {
                            env: config.ENV,
                            fncType: logName,
                            id: instanceId,
                            name: config.name,
                            version: version,
                            debug: config.debug || false
                          }));
                          _context27.prev = 12;
                          manifestCache2 = ManifestCacheManager(config == null ? void 0 : config.cacheManifest);
                          downloadManifest = DownloadManifest(config == null ? void 0 : config.http, manifestCache2);
                          internalConfig = InternalConfig({
                            emitter: emitter,
                            config: config,
                            id: instanceId,
                            opts: opts,
                            pluginManager: pluginManager,
                            manifestCache: manifestCache2,
                            downloadManifest: downloadManifest
                          });
                          _ref23 = opts || {}, skipValidation = _ref23.skipValidation, skipPreload = _ref23.skipPreload, skipGlobals = _ref23.skipGlobals, skipChunks = _ref23.skipChunks, skipLoadCSS = _ref23.skipLoadCSS;
                          pluginManager == null ? void 0 : pluginManager("onStart", {
                            config: config,
                            msg: "starting " + logName,
                            opts: opts,
                            isFirstRun: isFirstRun,
                            caller: caller,
                            version: version
                          });

                          if (skipValidation) {
                            _context27.next = 21;
                            break;
                          }

                          _context27.next = 21;
                          return ConfigValidation(internalConfig);

                        case 21:
                          if (isMfeLoad) {
                            _context27.next = 24;
                            break;
                          }

                          _context27.next = 24;
                          return RenderingEngine(internalConfig);

                        case 24:
                          if (skipPreload) {
                            _context27.next = 27;
                            break;
                          }

                          _context27.next = 27;
                          return PreloadHighPriorityFiles(internalConfig);

                        case 27:
                          if (skipChunks) {
                            _context27.next = 30;
                            break;
                          }

                          _context27.next = 30;
                          return LoadChunks(internalConfig);

                        case 30:
                          if (skipGlobals) {
                            _context27.next = 33;
                            break;
                          }

                          _context27.next = 33;
                          return LoadGlobalFiles(internalConfig);

                        case 33:
                          if (skipLoadCSS) {
                            _context27.next = 36;
                            break;
                          }

                          _context27.next = 36;
                          return LoadCSS(internalConfig);

                        case 36:
                          _context27.next = 38;
                          return LoadMainFiles(internalConfig);

                        case 38:
                          _context27.next = 44;
                          break;

                        case 40:
                          _context27.prev = 40;
                          _context27.t0 = _context27["catch"](12);
                          pluginManager == null ? void 0 : pluginManager("onError", {
                            msg: "there was an issue loading " + logName,
                            error: _context27.t0,
                            id: instanceId,
                            caller: caller
                          });
                          return _context27.abrupt("return", reject(_context27.t0));

                        case 44:
                          _context27.prev = 44;
                          pluginManager == null ? void 0 : pluginManager("onMessage", {
                            msg: "finished loading " + logName,
                            id: instanceId,
                            time: timeMeasure(t0),
                            caller: caller
                          });
                          return _context27.finish(44);

                        case 47:
                          if (!isMfeLoad) {
                            emitter.emit("mfe_loaded", true);
                          }

                          isMferLoaded = true;
                          isFirstRun = false;

                          if (!isSSR() && (opts == null ? void 0 : opts.useQueueForInitialMfeLoad) && mfeLoadQueue.length > 0) {
                            (function () {
                              var conf = mfeLoadQueue.shift();
                              if (conf) MicrofrontEndConfig(__spreadProps(__spreadValues(__spreadValues({}, config), conf), {
                                emitter: emitter
                              }), opts, true);
                            })();
                          }

                          pluginManager == null ? void 0 : pluginManager("onEnd", {
                            msg: "done",
                            caller: caller,
                            time: timeMeasure(t0),
                            id: instanceId
                          });
                          return _context27.abrupt("return", resolve({
                            id: instanceId,
                            isLoaded: true,
                            emitter: emitter
                          }));

                        case 53:
                        case "end":
                          return _context27.stop();
                      }
                    }
                  }, _callee27, null, [[12, 40, 44, 47]]);
                }));
              })();
            }));

          case 1:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));
};

var defaultOpts = {
  useQueueForInitialMfeLoad: true,
  singleton: true
};

var _Singleton = /*#__PURE__*/function () {
  function _Singleton(config, opts) {
    return MicrofrontEndConfig(config, opts, false);
  }

  _Singleton.getInstance = function getInstance(config, opts) {
    if (opts === void 0) {
      opts = defaultOpts;
    }

    var options = merge(opts, defaultOpts);

    if (!_Singleton.instance || !(options == null ? void 0 : options.singleton)) {
      _Singleton.instance = new _Singleton(config, options);
    }

    return _Singleton.instance;
  };

  return _Singleton;
}();

__publicField(_Singleton, "instance");

var Singleton = _Singleton;
var MfeConfig = Singleton.getInstance;

var MfeLoadError = /*#__PURE__*/function (_Error12) {
  _inheritsLoose(MfeLoadError, _Error12);

  function MfeLoadError(message) {
    var _this12;

    _this12 = _Error12.call(this, message) || this;
    _this12.name = "MfeLoadError";
    return _this12;
  }

  return MfeLoadError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var MfeLoad = function MfeLoad(_0) {
  for (var _len3 = arguments.length, _1 = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    _1[_key3 - 1] = arguments[_key3];
  }

  return __async(void 0, [_0].concat(_1), /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(config, opts, enforceMfeConfigRun) {
    var mainMferConfig, id, mainMferOpts, emitter, mfeLoadConfig, mfeLoadOpts;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            if (opts === void 0) {
              opts = defaultOpts;
            }

            if (enforceMfeConfigRun === void 0) {
              enforceMfeConfigRun = false;
            }

            mainMferConfig = MfeInternalConfig.config, id = MfeInternalConfig.id, mainMferOpts = MfeInternalConfig.opts, emitter = MfeInternalConfig.emitter;

            if (!((!mainMferConfig || id === "") && enforceMfeConfigRun)) {
              _context29.next = 5;
              break;
            }

            return _context29.abrupt("return", Promise.reject(new MfeLoadError("MfeConfig needs to run before MfeLoad")));

          case 5:
            mfeLoadConfig = __spreadValues(__spreadValues({
              emitter: emitter
            }, mainMferConfig), config);
            mfeLoadOpts = __spreadValues(__spreadValues({
              id: id
            }, mainMferOpts), opts);
            return _context29.abrupt("return", MicrofrontEndConfig(mfeLoadConfig, mfeLoadOpts, true, !mainMferConfig || id === ""));

          case 8:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }));
};

var RemoveGlobalModule = function RemoveGlobalModule(moduleName) {
  return globalThis[moduleName] = null;
}; //! we need to check if module name matches what was inside the library.
//! moduleFiles in array will be deprecated at a later time


export { MfeConfig, MfeLoad, MfeLoadError, MicrofrontEndConfig, RemoveGlobalModule, defaultOpts, isSSR };